export default "/images/7bcf0dc9592c1ed17d67e0e95ab159e1.avif";